var map = {
	"./AdGuardDnsInfo.vue": [
		"f258",
		"chunk-88331f84"
	],
	"./AdGuardFilterStatus.vue": [
		"6750",
		"chunk-7c4d77dc"
	],
	"./AdGuardStats.vue": [
		"4aa6",
		"chunk-50f31ec3",
		"chunk-284f6914"
	],
	"./AdGuardTopDomains.vue": [
		"72ed",
		"chunk-11e20f6f"
	],
	"./AnonAddy.vue": [
		"a492",
		"chunk-03c5a0ba"
	],
	"./Apod.vue": [
		"64ab",
		"chunk-bd9012c4"
	],
	"./BlacklistCheck.vue": [
		"b5ef",
		"chunk-21680640"
	],
	"./Blank.vue": [
		"c16a",
		"chunk-665a1900"
	],
	"./Clock.vue": [
		"5e2a",
		"chunk-736b2ef0"
	],
	"./CodeStats.vue": [
		"d7a5",
		"chunk-50f31ec3",
		"chunk-aa9cebcc"
	],
	"./CovidStats.vue": [
		"714f",
		"chunk-50f31ec3",
		"chunk-781da5fb"
	],
	"./CryptoPriceChart.vue": [
		"679e",
		"chunk-50f31ec3",
		"chunk-75cc9f4d"
	],
	"./CryptoWatchList.vue": [
		"c772",
		"chunk-b7e4a5ce"
	],
	"./CustomSearch.vue": [
		"8e89",
		"chunk-674ac328"
	],
	"./CveVulnerabilities.vue": [
		"c632",
		"chunk-29548417"
	],
	"./DomainMonitor.vue": [
		"3bae",
		"chunk-7e15df28"
	],
	"./DroneCi.vue": [
		"ebe5",
		"chunk-49f2d909"
	],
	"./EmbedWidget.vue": [
		"ec79",
		"chunk-c02e690a"
	],
	"./EthGasPrices.vue": [
		"91f0",
		"chunk-50f31ec3",
		"chunk-14192a80"
	],
	"./ExchangeRates.vue": [
		"a65f",
		"chunk-04659cb4"
	],
	"./Flights.vue": [
		"a75b",
		"chunk-0894290e"
	],
	"./GitHubProfile.vue": [
		"e160",
		"chunk-0f886a7e"
	],
	"./GitHubTrending.vue": [
		"3134",
		"chunk-2f7cf238"
	],
	"./GlAlerts.vue": [
		"6193",
		"chunk-4ab61964"
	],
	"./GlCpuCores.vue": [
		"3237",
		"chunk-92c623f0"
	],
	"./GlCpuGauge.vue": [
		"9304",
		"chunk-445cc501"
	],
	"./GlCpuHistory.vue": [
		"0949",
		"chunk-50f31ec3",
		"chunk-73f090a0"
	],
	"./GlCpuSpeedometer.vue": [
		"29f0",
		"chunk-08ca355a"
	],
	"./GlCpuTemp.vue": [
		"6134",
		"chunk-1b35c628"
	],
	"./GlDiskIo.vue": [
		"35a8",
		"chunk-15b37c0a"
	],
	"./GlDiskSpace.vue": [
		"1f55",
		"chunk-070d32ac"
	],
	"./GlIpAddress.vue": [
		"82d1",
		"chunk-6b5de1e1"
	],
	"./GlLoadHistory.vue": [
		"ce80",
		"chunk-50f31ec3",
		"chunk-0044633e"
	],
	"./GlMemGauge.vue": [
		"2af9",
		"chunk-187213fc"
	],
	"./GlMemHistory.vue": [
		"dccf",
		"chunk-50f31ec3",
		"chunk-7132ce43"
	],
	"./GlMemSpeedometer.vue": [
		"8f1b",
		"chunk-460e6092"
	],
	"./GlNetworkInterfaces.vue": [
		"4558",
		"chunk-77caf4c4"
	],
	"./GlNetworkTraffic.vue": [
		"bf13",
		"chunk-50f31ec3",
		"chunk-ff6de53a"
	],
	"./GlSystemLoad.vue": [
		"7ce6",
		"chunk-50f31ec3",
		"chunk-c0f28fc6"
	],
	"./GluetunStatus.vue": [
		"4841",
		"chunk-44cb61f1"
	],
	"./HackernewsTrending.vue": [
		"2213",
		"chunk-4ef6dcf5"
	],
	"./HealthChecks.vue": [
		"dac2",
		"chunk-ecec4fc4"
	],
	"./IframeWidget.vue": [
		"2386",
		"chunk-7b5f88fd"
	],
	"./ImageWidget.vue": [
		"2356",
		"chunk-b54d81ae"
	],
	"./Jokes.vue": [
		"7b50",
		"chunk-cee89fa8"
	],
	"./Linkding.vue": [
		"7b54",
		"chunk-677c8830"
	],
	"./MullvadStatus.vue": [
		"1e8e",
		"chunk-4f2c58c5"
	],
	"./Mvg.vue": [
		"c9a3",
		"chunk-c8bd4cd0"
	],
	"./MvgConnection.vue": [
		"ba75",
		"chunk-93c6be8c"
	],
	"./NdCpuHistory.vue": [
		"e641",
		"chunk-50f31ec3",
		"chunk-2ab49ff8"
	],
	"./NdLoadHistory.vue": [
		"47ad",
		"chunk-50f31ec3",
		"chunk-d42744f4"
	],
	"./NdRamHistory.vue": [
		"1afb",
		"chunk-50f31ec3",
		"chunk-0c51289a"
	],
	"./NewsHeadlines.vue": [
		"f406",
		"chunk-043d9c91"
	],
	"./NextcloudNotifications.vue": [
		"f48c",
		"chunk-0367deae"
	],
	"./NextcloudPhpOpcache.vue": [
		"8eac",
		"chunk-468d3a74"
	],
	"./NextcloudStats.vue": [
		"f9cc",
		"chunk-16e26d5d"
	],
	"./NextcloudSystem.vue": [
		"2f96",
		"chunk-50f31ec3",
		"chunk-180be55e"
	],
	"./NextcloudUser.vue": [
		"f298",
		"chunk-2642eaf9"
	],
	"./NextcloudUserStatus.vue": [
		"2937",
		"chunk-7bba3126"
	],
	"./PiHoleStats.vue": [
		"3ce5",
		"chunk-50f31ec3",
		"chunk-6ab1f28d"
	],
	"./PiHoleTopQueries.vue": [
		"7309",
		"chunk-3a3d0cd8"
	],
	"./PiHoleTraffic.vue": [
		"e61b",
		"chunk-50f31ec3",
		"chunk-2d225b78"
	],
	"./Proxmox.vue": [
		"8715",
		"chunk-7abb8001"
	],
	"./PublicHolidays.vue": [
		"79b9",
		"chunk-06ec1263"
	],
	"./PublicIp.vue": [
		"4f0c",
		"chunk-f43b0842"
	],
	"./RescueTime.vue": [
		"1b90",
		"chunk-f38e0ad2"
	],
	"./RssFeed.vue": [
		"4f87",
		"chunk-4cfc5864"
	],
	"./Sabnzbd.vue": [
		"2e26",
		"chunk-8db027b8"
	],
	"./SportsScores.vue": [
		"7fa8",
		"chunk-2925d418"
	],
	"./StatPing.vue": [
		"d71a",
		"chunk-e77c83e6"
	],
	"./StockPriceChart.vue": [
		"b1f5",
		"chunk-50f31ec3",
		"chunk-1e169674"
	],
	"./SynologyDownload.vue": [
		"5a4b",
		"chunk-edbdb67c"
	],
	"./SystemInfo.vue": [
		"0021",
		"chunk-50f31ec3",
		"chunk-0387fd77"
	],
	"./TacticalRMM.vue": [
		"93a5",
		"chunk-542a53f9"
	],
	"./TflStatus.vue": [
		"5d62",
		"chunk-b52460ac"
	],
	"./UptimeKuma.vue": [
		"709a",
		"chunk-38169201"
	],
	"./WalletBalance.vue": [
		"6d7b",
		"chunk-7ba8e45c"
	],
	"./Weather.vue": [
		"048f",
		"chunk-26dbf0a4"
	],
	"./WeatherForecast.vue": [
		"d76f",
		"chunk-0c7116ec"
	],
	"./WidgetBase.vue": [
		"2955"
	],
	"./XkcdComic.vue": [
		"a2e3",
		"chunk-4a72a42d"
	],
	"./ZPApiResponse.vue": [
		"c15a",
		"chunk-6884992f"
	],
	"./ZPButtonList.vue": [
		"d49d",
		"chunk-42ef73e8"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "50ed";
module.exports = webpackAsyncContext;